import { render, staticRenderFns } from "./DiscountInfo.vue?vue&type=template&id=1b6728d9&"
import script from "./DiscountInfo.vue?vue&type=script&lang=js&"
export * from "./DiscountInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports